export default "__VITE_ASSET__BgCRFgb5__";